import { TableCell, type TableCellProps } from '@mui/material'
import type { ReactElement } from 'react'

import { Text } from '@orus.eu/pharaoh'

export function TableCellHeader(props: TableCellProps): ReactElement {
  return (
    <TableCell {...props}>
      <Text variant="captionSemiBold">{props.children}</Text>
    </TableCell>
  )
}
